import React, { useEffect, useRef, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { getSelectedTabListView, getStoreLocalData, getUserData, setSelectedTabListView } from "../../utils/localStorage.js";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil.js";
import { storeCustomerInfoOrders } from "../../services/StoreOrder/StoreOrder.js";
import SchedularModal from "../SchedularModal.js";
import AdminMenu from "../AdminMenu.js";
import StoreMenu from "../StoreMenu.js";
import ButtonLink from "../../ButtonLink.js";
import useCustomerInfoOrders from "../StoreContext/useCustomerInfoOrders.js";
import { getBrandStoreById } from "../../services/StoreUsers/PostStoreUsers.js";
import { ProgressSpinner } from "primereact/progressspinner";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { DataView } from "primereact/dataview";

const { innerWidth: width, innerHeight: height } = window;

const CustomerInfoOrdersAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    orderFilterData,
    source,
    storeCustomerId,
    mobileNumber,
    typeOfOrder,
    navigateThrough,
    storeId,
  } = location.state || {}; // Fallback to prevent undefined errors

  const { userProfileRole, brandProfileData } = getUserData();

  const { storeLocalData } = getStoreLocalData();

  const userRole = userProfileRole;

  let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;

  const [storeData, setStoreData] = useState({});

  const {
    schedularDate,
    setSchedularDate,
    selectedStatus,
    setSelectedStatus,
    customerALLOrdersData,
    setCustomerALLOrdersData,
    statusTotalData,
    setStatusTotalData,
    sumOfGrandTotal,
    setSumOfGrandTotal,
    sumOfOrderCount,
    setSumOfOrderCount,
  } = useCustomerInfoOrders();

  const resetOrdersList = () => {
    const ordersStore = useCustomerInfoOrders.getState();


    // Reset Zustand store values
    ordersStore.setSchedularDate({});
    ordersStore.setSelectedStatus("ALL");
    ordersStore.setCustomerALLOrdersData([]);
    ordersStore.setStatusTotalData([]);
    ordersStore.setSumOfGrandTotal(0);
    ordersStore.setSumOfOrderCount(0);

    // Reset requestData
    const data = {
      storeId: storeId,
      statusIn:
        selectedStatus !== "ALL"
          ? selectedStatus
          : orderFilterData?.statusIn,
      recordType: orderFilterData?.recordType,
      startDate: localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(initialStartDate)),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date())),
    };

    // Explicitly fetch first page
    // fetch first page explicitly
    fetchStoreOrders(data); // pass 0 as page
  };

   const [tabularView, setTabularView] = useState(false);
    
      const handleTabListViewChange = async (selectedType) => {
        setTabularView(selectedType);
        await setSelectedTabListView(selectedType);
      };
    
      const fetchSelectedTabListView = async () => {
        try {
          const selectedInvoiceTypeData = await getSelectedTabListView();
          setTabularView(selectedInvoiceTypeData?.tabListView || "list");
        } catch {
          setTabularView("list");
        }
      };
  

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  // const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  // const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders
  // const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]); // Default to show all orders
  // const [recordType, setRecordType] = useState(""); // Default to show all orders
  const [loading, setLoading] = useState(false);
  // const [statusTotalData, setStatusTotalData] = useState([]);
  // const [sumOfGrandTotal, setSumOfGrandTotal] = useState(0);
  // const [sumOfOrderCount, setSumOfOrderCount] = useState(0);

  // const [schedularDate, setSchedularDate] = useState({});
  const [visible, setVisible] = useState(false);

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const fetchStoreUser = () => {
    getBrandStoreById(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreOrders = (data) => {
    setLoading(true);
    storeCustomerInfoOrders(storeId, storeCustomerId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const statusTotals = Res.reduce((acc, order) => {
            // Check if the status already exists in the accumulator
            const existingStatus = acc.find(
              (item) => item.status === order.status
            );

            if (existingStatus) {
              // If status exists, add the current order's grandTotal to the existing sum
              existingStatus.grandTotalSum += order.grandTotal;
              existingStatus.orderCount += 1; // Increment the order count
            } else {
              // If status does not exist, create a new object with the status, grandTotal, and order count
              acc.push({
                status: order.status,
                grandTotalSum: order.grandTotal,
                orderCount: 1,
              });
            }

            return acc;
          }, []);

          const totalGrandTotalSumData = statusTotals.reduce(
            (acc, item) => acc + item.grandTotalSum,
            0
          );
          const totalOrderCountData = statusTotals.reduce(
            (acc, item) => acc + item.orderCount,
            0
          );
          setStatusTotalData(statusTotals);
          setSumOfGrandTotal(totalGrandTotalSumData);
          setSumOfOrderCount(totalOrderCountData);
          setCustomerALLOrdersData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  let initialStartDate = new Date(orderFilterData?.startDate);
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  useEffect(() => {
    const data = {
      storeId: storeId,
      statusIn:
        selectedStatus !== "ALL" ? selectedStatus : orderFilterData?.statusIn,
      recordType: orderFilterData?.recordType,
      startDate: localeDateStartDate(new Date(schedularDate.startDate)) || localeDateStartDate(new Date(initialStartDate)),
      endDate: localeDateEndDate(new Date(schedularDate.endDate)) || localeDateEndDate(new Date(new Date())),
    };
    fetchStoreOrders(data);
    fetchStoreUser();
    fetchSelectedTabListView();
  }, [schedularDate, selectedStatus, source]);

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const renderPaymentModeButtons = () => {
    return statusTotalData.map((item) => (
      <div
        key={item.status}
        style={{ backgroundColor: OrderStatusColors[item.status] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {item.orderCount} - {item.status.replace(/_/g, " ")} ({storeLocalData?.currencySymbol}{" "}
          {item.grandTotalSum.toFixed(0)})
        </p>
      </div>
    ));
  };

   const itemTemplate = (order, index) => {
      const orderStatusColor =
        OrderStatusColors[order.status] || OrderStatusColors.DEFAULT;
      const displayDate =
        order.status === "DELIVERED" || order.status === "DONE"
          ? order.deliveredOn
          : order.deliveryOn;
      const displayBalanceText =
          order.status === "DELIVERED"
            ? '| Balance'
            : '';
            const displayBalanceAmount =
          order.status === "DELIVERED"
                ? '| ' + Number(order.balanceAmount)?.toFixed(enabledAmountRoundOffAdmin)
            : '';
      const displayDeliveryDateText =
        order.status === "DELIVERED" || order.status === "DONE"
          ? "Delivered On"
          : "Delivery Date";
      const formattedCreatedDate = formatDateNew(order.createdDate);
      const formattedDeliveryDate = formatDateNew(displayDate);
      return (
        <Accordion>
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`${
              order.invoiceNo || "N/A"
            } | ${formattedCreatedDate}  ${order.status.replace(/_/g, " ")}`}
          >
            <div
              className="cursor-pointer"
              onClick={() =>
                navigate("/OrdersGarmentInfo", {
                  state: {
                    storeIdValue: order.storeId,
                    bookingOrderId: order.id,
                    storeCustomerId: order.storeCustomerId,
                    navigateThrough: 'GoBack'
                  },
                })
              }
            >
              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">Order No:</p>
                  <p className="text-lg font-bold capitalize">
                    {order.orderNo || "N/A"}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Invoice No:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {order.invoiceNo || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Order Source:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {order.orderSource
                      ? order.orderSource.replace(/_/g, " ")
                      : ""}
                  </p>
                </div>
              </div>
  
              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Customer Name:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {order.customerName || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Customer Mobile No.:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {order.customerMobile || 0}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">Remarks:</p>
                  <p className="text-lg font-bold capitalize">
                    {order.remarks || 0}
                  </p>
                </div>
              </div>
              <div className="flex-row">
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    {displayDeliveryDateText}:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {formattedDeliveryDate}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">
                    Invoice {displayBalanceText} Amount:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {Number(order.grandTotal)?.toFixed(enabledAmountRoundOffAdmin)} {displayBalanceAmount}
                  </p>
                </div>
                <div className="col-4">
                  <p className="text-base font-semiBold capitalize">Status:</p>
                  <p className="text-lg font-bold capitalize">
                    <span
                      style={{
                        color:
                          OrderStatusColors[order.status] ||
                          OrderStatusColors.DEFAULT,
                      }}
                    >
                      {order.status || "Unknown"}
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex-row">
                <div className="col-8">
                  <p className="text-base font-semiBold capitalize">
                    Address:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {order.customerAddress}
                  </p>
                </div>
                {order.deliveryRemarks && (
                <div className="col-4">
                    <p className="text-base font-semiBold capitalize">
                      Delivery Remark:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {order.deliveryRemarks}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      );
    };


  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

    const BalanceAmountTemplate = (rowData) => {
      return (
        <div className="flex flex-row justify-content-between gap-2">
          <div>
            <span className="text-md">{rowData.balanceAmount}</span>
          </div>
           
        </div>
      );
    };
  
    const PcsBodyTemplate = (rowData) => {
      return (
        <div className="flex flex-row justify-content-between gap-2">
          <div
            style={{ backgroundColor: "#09B4AA" }}
            className="px-2 border-round-md cursor-pointer"
            onClick={() =>
              navigate("/GarmentTags", {
                state: {
                  bookingOrderId: rowData.id,
                  storeCustomerId: rowData.storeCustomerId,
                  orderItemId: null,
                  customerALLOrdersData,
                  isOrders: true,
                },
              })
            }
          >
            <span className="text-white text-lg font-bold uppercase">
              {rowData.itemGarmentCount}
            </span>
          </div>
        </div>
      );
    };
  
    const statusBodyTemplate = (rowData) => {
      return (
        <div
          className="flex flex-row justify-content-between cursor-pointer"
          onClick={() =>
            navigate("/ViewInvoice", {
              state: {
                bookingOrderId: rowData.id,
                storeCustomerId: rowData.storeCustomerId,
                navigateThrough: "GoBack",
              },
            })
          }
        >
          <span style={{ color: OrderStatusColors[rowData.status] }}>
            {rowData?.status?.replace(/_/g, " ")}
          </span>
          <img
            src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
            style={{
              // height: 31,
              width: 21,
              backgroundColor: "#FFF9DE",
              borderColor: "#F5C43A",
            }}
          />
        </div>
      );
    };
  
    const urgentDeliveryTemplate = (rowData) => {
      return rowData?.urgentDelivery ? (
        <img
          src={
            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
          }
          style={{ width: "25" }}
        />
      ) : (
        <img
          src={
            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
          }
          style={{ width: "25" }}
        />
      );
    };
  
    const homeDeliveryTemplate = (rowData) => {
      return rowData?.deliveryRequest ? (
        <img
          src={
            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
          }
          style={{ width: "15" }}
        />
      ) : (
        <img
          src={
            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
          }
          style={{ width: "15" }}
        />
      );
    };
  
    const invoiceBodyTemplate = (rowData) => {
      return (
        <div
          className="cursor-pointer"
          onClick={() =>
            
              navigate("/OrdersGarmentInfo", {
                state: {
                  storeIdValue: rowData.storeId,
                  bookingOrderId: rowData.id,
                  storeCustomerId: rowData.storeCustomerId,
                },
              })
               
          }
        >
          <span style={{ color: "blue", textDecoration: "underline" }}>
            {rowData?.invoiceNo}
          </span>
        </div>
      );
    };
  
    const customerName = (rowData) => {
      return (
        <div>
          <p>
            {rowData?.customerName?.replace(/_/g, " ").substring(0, 16)}
            {rowData?.customerName?.length > 16 ? "..." : ""}
          </p>
        </div>
      );
    }
  
     const RenderTabView = () => {
        return (
          <DataTable
            showGridlines
            value={customerALLOrdersData}
            // header={header}
            paginator
            rows={50}
            rowsPerPageOptions={[50, 75, 100]}
            tableStyle={{ minWidth: "120rem" }}
            stripedRows
          >
            <Column
              field="invoiceNo"
              header="Invoice No"
              style={{
                width: "85px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={invoiceBodyTemplate}
            ></Column>
            <Column
              field="createdDate"
              header="Booking Date"
              style={{
                width: "110px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={(rowData) => formatDateNew(rowData?.createdDate)}
            />
            <Column
              field="deliveryOn"
              header="Due Date"
              style={{
                width: "110px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={(rowData) =>
                rowData.status === "DELIVERED" || rowData.status === "DONE"
                  ? formatDateNew(rowData.deliveredOn)
                  : formatDateNew(rowData.deliveryOn)
              }
            ></Column>
            <Column
              field="customerName"
              header="Customer Name"
              style={{
                width: "140px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={customerName}
            ></Column>
            <Column
              field="customerMobile"
              header="Mobile"
              style={{
                width: "100px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={(rowData) => rowData?.customerMobile?.replace(/_/g, " ")}
            ></Column>
            <Column
              field="status"
              header="Status"
              style={{
                width: "170px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={statusBodyTemplate}
            ></Column>
            {/* <Column
                field="orderNo"
                header="Order No"
                body={(rowData) => rowData?.orderNo}
              /> */}
    
            <Column
              field="itemGarmentCount"
              header="Pcs"
              style={{
                width: "50px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              // body={(rowData) => rowData?.itemGarmentCount}
              body={PcsBodyTemplate}
            ></Column>
            <Column
              field="grandTotal"
              header="Amount"
              style={{
                width: "65px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
            ></Column>
            <Column
              field="balanceAmount"
              header="Balance"
              style={{
                width: "65px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={BalanceAmountTemplate}
            ></Column>
            <Column
              field="urgentDelivery"
              header="UD"
              style={{
                width: "30px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={urgentDeliveryTemplate}
            // body={(rowData) => (rowData?.urgentDelivery ? "YES" : "NO")}
            ></Column>
            <Column
              field="deliveryRequest"
              header="HD"
              style={{
                width: "30px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={homeDeliveryTemplate}
            // body={(rowData) => (rowData?.deliveryRequest ? "YES" : "NO")}
            ></Column>
            {/* <Column field="customerName" header="Customer Name"></Column>
              <Column field="customerMobile" header="Customer Mobile"></Column> */}
            {/* <Column
                field="deliveredOn"
                header="Delivered On"
                body={(rowData) => rowData.status === "DELIVERED" || rowData.status === "DONE"
                  ? formatDate(rowData.deliveredOn) : ""}
              ></Column> */}
    
            <Column
              field="orderSource"
              header="Order Source"
              style={{
                width: "100px",
                paddingVertical: 1,
                paddingLeft: 5,
                paddingRight: 1,
              }}
              body={(rowData) => rowData?.orderSource?.replace(/_/g, " ")}
            ></Column>
            <Column
              field="remarks"
              header="Remarks"
              style={{ paddingVertical: 1, paddingLeft: 5, paddingRight: 1 }}
            ></Column>
            <Column
              field="deliveryRemarks"
              header="Delivery Remarks"
              style={{ paddingVertical: 1, paddingLeft: 5, paddingRight: 1 }}
            ></Column>
          </DataTable>
        );
      };
  

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/CustomerInfo", {
                      state: {
                        storeCustomerId: storeCustomerId,
                        storeId: storeId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                All Orders
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>


          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>
          <div
            onClick={() => resetOrdersList()}
            className="mx-2 cursor-pointer"
          >
            <img src={"images/closeFilter.png"} style={{ width: 27 }} />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-4">
          <div
            className="flex gap-3 mb-3 pb-1 new-scroll-bar"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{ backgroundColor: "#2B70D7" }}
              className="px-3 py-2 border-round-md"
            >
              <p className="text-white text-lg font-bold uppercase">
              {sumOfOrderCount} - All ({storeLocalData?.currencySymbol} {sumOfGrandTotal.toFixed(0)})
              </p>
            </div>

            {renderPaymentModeButtons()}
          </div>

           {loading ? (
                            <div style={{ flex: 1 }}>
                              <div className="text-center">
                                <ProgressSpinner
                                  style={{ width: "70px", height: "70px" }}
                                  strokeWidth="4"
                                  fill="var(--surface-ground)"
                                  animationDuration="2s"
                                />
                              </div>
                            </div>
                          ) : customerALLOrdersData?.length > 0 ? (
                            <div>
                              <div>
                                {tabularView === "tab" && (
                                  <div
                                    className="scroll-bar mb-2"
                                    style={{
                                      height: height > 600 ? 420 : 400,
                                      overflowY: "scroll",
                                    }}
                                  >
                                    <div className="report-table">
                                      <div className="tab-view-table">{RenderTabView()}</div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div style={{ display: tabularView === "tab" ? "none" : "" }}>
                                <DataView
                                  value={customerALLOrdersData}
                                  listTemplate={listTemplate}
                                  paginator
                                  rows={20}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="flex justify-content-center align-items-center">
                              <p className="text-xl font-semi-bold">No Order Found</p>
                            </div>
                          )}
                            
      </div>
      <SchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        typeOfOrder={orderFilterData.recordType}
      />
      {userRole === "BY_ADMIN" ||
      userRole === "BY_SUB_ADMIN_USER" ||
      userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
    </div>
  );
};

export default CustomerInfoOrdersAdmin;
